import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonNav, ModalController } from '@ionic/angular';
import { CaseService } from 'src/app/services/case.service';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';
import { PaymentService } from 'src/app/services/payment.service';
import { PaymentGatewaysPage } from '../payment-plan/payment-gateways/payment-gateways.page';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-payment-plan-request',
  templateUrl: './payment-plan-request.page.html',
  styleUrls: ['./payment-plan-request.page.scss'],
})
export class PaymentPlanRequestPage implements OnInit {
  @Input() caseId;
  @Input() totalOutstanding;
  @Input() isGroupArrangement;
  @Input() debtorDetails;
  @Input() caseData;
  paymentPlanForm: FormGroup;
  saveBtnDisabled = false;
  selectOptions = {};
  frequency = [
    { id: 'Monthly by date', label: this.translate.instant('PAYMENT.FREQUENCY.MONTHLY_BY_DATE') },
    { id: 'One time final payment', label: this.translate.instant('PAYMENT.FREQUENCY.ONE_TIME_FINAL_PAYMENT') },
    { id: 'Weekly By day of the week', label: this.translate.instant('PAYMENT.FREQUENCY.WEEKLY_BY_DAY_OF_THE_WEEK') },
    { id: 'Monthly by day', label: this.translate.instant('PAYMENT.FREQUENCY.MONTHLY_BY_DAY') },
    { id: 'Fortnightly', label: this.caseService.isClient('simonsagency') ? 'Bi-weekly' : this.translate.instant('PAYMENT.FREQUENCY.FORTNIGHTLY') },
    { id: 'four weekly', label: this.translate.instant('PAYMENT.FREQUENCY.FOUR_WEEKLY') },
    { id: 'Last day of the month', label: this.translate.instant('PAYMENT.FREQUENCY.LAST_DAY_OF_THE_MONTH') },
    { id: 'First day of the month', label: this.translate.instant('PAYMENT.FREQUENCY.FIRST_DAY_OF_THE_MONTH') },
    { id: 'Last work day of the month', label: this.translate.instant('PAYMENT.FREQUENCY.LAST_WORK_DAY_OF_THE_MONTH') },
    { id: 'Last Friday of the month', label: this.translate.instant('PAYMENT.FREQUENCY.LAST_FRIDAY_OF_THE_MONTH') },
  ];
  datepicker_date_format = 'DD/MM/YYYY';
  datemin = moment().format('YYYY-MM-DD');
  datemax = moment().add('100', 'years').format('YYYY-MM-DD');
  message = '';
  isPaymentProposal = false;

  constructor(
    private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private caseService: CaseService,
    private commonService: CommonService,
    private ionNav: IonNav,
    private paymentService: PaymentService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (localStorage.getItem('language') != 'en') {
      this.message = portalSettings['interest_message_' + localStorage.getItem('language')] ||  portalSettings?.interest_message;
    } else {
      this.message = portalSettings?.interest_message;
    }
    this.initForm();
  }

  initForm() {
    this.paymentPlanForm = this.formBuilder.group({
      frequency: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      additionalInfo: [''],
      phoneNumber: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      date: ['', [Validators.required]],
    });
    let phoneNumber =
      this.debtorDetails?.debtor_mobile != ''
        ? this.debtorDetails.debtor_mobile
        : this.debtorDetails?.debtor_phone != ''
        ? this.debtorDetails.debtor_phone
        : '';
    if (phoneNumber == '') {
      if (this.debtorDetails.phone_numbers.length > 0) {
        phoneNumber = this.debtorDetails.phone_numbers[0].number;
      }
    }
    let email =
      this.debtorDetails?.debtor_email != ''
        ? this.debtorDetails.debtor_email
        : '';
    if (email == '') {
      if (this.debtorDetails.emails.length > 0) {
        email = this.debtorDetails.emails[0].account;
      }
    }
    this.paymentPlanForm.controls.phoneNumber.setValue(phoneNumber);
    this.paymentPlanForm.controls.email.setValue(email);

    let portalSettings = JSON.parse(localStorage.getItem('portal_settings'));
    if (portalSettings?.datepicker_date_format) {
      this.datepicker_date_format = portalSettings.datepicker_date_format;
    }
  }

  async save() {
    console.log("save payment plan");
    if (this.paymentPlanForm.valid) {
      console.log("payment plan form is valid");

      this.saveBtnDisabled = true;
      this.isPaymentProposal = this.caseService.isClient('receive') ? true : false;
      let paymentPlan = {};
      if (this.paymentPlanForm.value.amount <= 0) {
        this.commonService.showToast(this.translate.instant('PAYMENT.AMOUNT_GREATER_THAN', {amount: 0}), 'danger');
        this.saveBtnDisabled = false;
        return;
      }
      console.log(this.caseService.isClient('receive'));
      paymentPlan = {
        caseid: this.caseId,
        frequency: this.paymentPlanForm.value.frequency,
        amount: this.paymentPlanForm.value.amount,
        date: moment(this.paymentPlanForm.value.date).format(this.datepicker_date_format),
        phoneNumber: this.paymentPlanForm.value.phoneNumber,
        additionalInfo: this.paymentPlanForm.value.additionalInfo,
        email: this.paymentPlanForm.value.email,
        isGroupArrangement: this.isGroupArrangement,
      };

      if(this.isPaymentProposal == true) {
        console.log("PaymentProposal is true");

        let frequency = this.paymentPlanForm.value.frequency;
        if (frequency == 'Monthly by date') {
          paymentPlan['frequency'] = 4;
        } else if (frequency == 'One time final payment') {
          paymentPlan['frequency'] = 2;
        } else if (frequency == 'Weekly By day of the week') {
          paymentPlan['frequency'] = 3;
        } else if (frequency == 'Monthly by day') {
          paymentPlan['frequency'] = 5;
        } else if (frequency == 'Fortnightly') {
          paymentPlan['frequency'] = 6;
        } else if (frequency == 'four weekly') {
          paymentPlan['frequency'] = 7;
        } else if (frequency == 'Last day of the month') {
          paymentPlan['frequency'] = 8;
        } else if (frequency == 'First day of the month') {
          paymentPlan['frequency'] = 9;
        } else if (frequency == 'Last work day of the month') {
          paymentPlan['frequency'] = 10;
        } else if (frequency == 'Last Friday of the month') {
          paymentPlan['frequency'] = 11;
        }

        if (paymentPlan['date']) {
          this.caseService.setPaymentData({
            dateType: null,
            date: paymentPlan['date'],
            total:  parseInt(this.paymentService.getCaseOutStanding(this.caseData), 10),
            freq: paymentPlan['frequency'],
            amount: parseInt(paymentPlan['amount'], 10),
            email: paymentPlan['email'],
            isGroupArrangement: this.isGroupArrangement,
            caseData: this.caseData,
            scheduledAmount: parseInt(paymentPlan['amount'], 10),
            caseId: this.caseId,
            isPaymentProposal: this.isPaymentProposal,
          });
          this.ionNav.push(PaymentGatewaysPage, {
            caseData: this.caseData,
            planType: 'plan',
            selectedPlanData: null,
          });
        }
      } else {
        console.log("PaymentProposal is false");

        this.caseService.paymentPlan(paymentPlan).subscribe((res: any) => {
          this.saveBtnDisabled = false;
          if (res.result) {
            this.commonService.showToast(res['data']['message'], 'success');
            this.ionNav.popToRoot();
          } else {
            this.commonService.showToast(res['message'], 'danger');
            this.dismiss();
          }
        });
      }
    } else {
      console.log("payment plan form is invalid");
    }
  }

  async dismiss() {
    this.ionNav.pop();
  }
  cancel() {
    this.dismiss();
  }
}
